import { render } from "./FreedomPrayer.vue?vue&type=template&id=0fedc540&scoped=true"
import script from "./FreedomPrayer.vue?vue&type=script&lang=js"
export * from "./FreedomPrayer.vue?vue&type=script&lang=js"

import "./FreedomPrayer.vue?vue&type=style&index=0&id=0fedc540&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fedc540"]])

export default __exports__